import { PractitionerPreferenceScreenWithBookingData } from "~/features/book-appointment/PractitionerPreferenceScreen";

const Component = () => {
  return <PractitionerPreferenceScreenWithBookingData />;
};

export default Component;
